<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Angebot Management

  section.modal-card-body
    ValidationObserver(ref="form")
      .generic-wrapper
        .container
          .two-column
            .column
              h2.title.is-6 E-Mail Anhang
              iframe(ref="pdf-preview").pdf-preview
            .column
              .form.w640
                h2.title.is-6 E-Mail schreiben
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")
              //- .spacer.sm
              //- .form.w640
                h2.title.is-6 Optionale Einleitung
                ValidationProvider(name="Optionale Einleitung" rules="" v-slot="{ errors, valid }") 
                  b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.optionalOfferText" type="textarea")
                b-button(type="is-light" @click="generatePDF()") PDF aktualisieren

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-secondary(@click="sendOffer()") Speichern ohne Senden
    button.button.is-primary(@click="sendOffer('sendEmail')") Senden & Speichern
</template>

<script>
import { DateTime } from 'luxon';
export default {
  props: {
    rentObject: {
      type: Object
    },
    booking: {
      type: Object
    },
    bookingInformation: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    updatePreviewMode: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null,
        optionalOfferText: null
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  async mounted() {
    if (this.booking.id && this.updatePreviewMode === false) {
      this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
      this.fullBooking = {...this.fullBooking, ...this.booking, customer: this.fullBooking.customer} // this way we still have the imagaes 
    } else {
      this.fullBooking = this.booking;
    }
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    let offerTemplate = emailTemplates.find(e => e.uuid === 'OFFER_EMAIL');
    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: offerTemplate, booking: this.fullBooking});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
    this.generatePDF();
  },
  methods: {
    async generatePDF() {
      const loadingComponent = this.$buefy.loading.open();
      
      const pdfArraybuffer = await this.$store.dispatch("rentObjectBookings/offerPDFPreview", {id: this.booking.id && this.updatePreviewMode === false ? this.booking.id : 0, optional: this.formData.optionalOfferText, bookingData: {...this.fullBooking, ...this.bookingInformation?.items}});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      
      loadingComponent.close();
    },
    sendOffer(sendEmail) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        if (this.updatePreviewMode) {
          // First we create the booking
          await this.$store.dispatch("rentObjectBookings/update", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});

          await this.$store.dispatch("offers/create", {...this.formData, rentObjectBookingId: this.booking.id, sendEmail});
          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId, bookingStatusId: this.booking.bookingStatusId}});
        } else {
          await this.$store.dispatch("offers/create", {...this.formData, rentObjectBookingId: this.booking.id, sendEmail});
          this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId, bookingStatusId: this.booking.bookingStatusId}});
        }
        loadingComponent.close();
        this.$emit('refreshInbox');
        this.$emit('close');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>